export const GET_SUGGESTIONS = "Get Suggestion"
export const GET_COMPANY_SUGGESTIONS = "Get Company Suggestion"
export const CLEAN_SUGGESTIONS = "Clean Suggestion"
export const FETCH_SUGGESTIONS_SUCCESS = "Get Suggestion success"
export const FETCH_SUGGESTIONS_FAILURE = "Get Suggestion failure"

export const GET_PORT_SUGGESTIONS = "Get Port Suggestion"

export const getCompanySuggestions = (data) => ({
  type: GET_COMPANY_SUGGESTIONS,
  payload: data
});

export const getSuggestions = (data) => ({
  type: GET_SUGGESTIONS,
  payload: data
});

export const getPortSuggestions = (data) => ({
  type: GET_PORT_SUGGESTIONS,
  payload: data
});


export const cleanSuggestions = () => ({
  type: CLEAN_SUGGESTIONS,
});
